import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const url = (path: string) => `${environment.server.apiURL}/Membership${path}`;
const json = { "Content-Type": "application/json" };

/** Memberships a club sells, and who holds one. */
export const MembershipService = {
	getProducts: async () => await FetchInterceptor(url("/Products"), {headers: json, method: "GET"}),
	addProduct: async (data: any) => await FetchInterceptor(url("/Products"), {body: JSON.stringify(data), headers: json, method: "POST"}),
	updateProduct: async (id: number, data: any) => await FetchInterceptor(url(`/Products/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	removeProduct: async (id: number) => await FetchInterceptor(url(`/Products/${id}`), {headers: json, method: "DELETE"}),
	getMembers: async (query: string) => await FetchInterceptor(url(`/Members?${query}`), {headers: json, method: "GET"})
};
